


















import settings from '@/settings.coffee'


export default {
    "name": "ImageUploader"
    "props": {
        "info":{
            "type": Object
        }
    }
    "computed":{}
    "methods":
        "args": (img_data, img_name)->
            self = this
            args = []
            for param in self.info.params
                args.push(self[param])
            args.push(img_data)
            args.push(img_name)
            return args
        "upload_image": (image)->
            if not image?
                return
            self = this
            reader = new FileReader()
            reader.onload = (aImg)->
                self.info.upload_call_back(aImg.target.result, image.name)
            reader.readAsDataURL(image)
                        
        "filesChanged": (arg, arg2, arg3)->
            self = this
            if arg2[0].size < 2000000
                self.upload_image(arg2[0])
            else
                self.$store.dispatch("notify",{
                    level: "danger",
                    text: "Cet image est trop lourde"
                })
        "deletePicture": ()->
            self = this
            self.info.delete_callback()
}
